import { Serializable } from "@/core/api/decorators/serializable_decorator"
import { UserModel } from "./userModel"
import { UserManagerType } from "../constants/userManagerType"
import { ApprovalStatus } from "@/modules/approval/constants/approvalStatus"

@Serializable
export class UserManagerModel extends UserModel {
  level: number = 0
  managerType: UserManagerType = UserManagerType.NotSet
  approvalStatus: ApprovalStatus = ApprovalStatus.Waiting
  constructor(
    data: {
      uid: string
      spaceUserId: string
      firstname: string
      lastname: string
      email: string
      phone: string
      title: string
      level: number
      managerType: UserManagerType
      approvalStatus?: ApprovalStatus
      roles: string[]
    } | null = null,
  ) {
    super(data)
    if (data) {
      this.level = data.level
      this.managerType = data.managerType
      this.approvalStatus = data.approvalStatus ?? ApprovalStatus.Waiting
      this.roles = data.roles || []
    }
  }
}
